export const HEADER_FONT = ''
export const PARAGRAPH_FONT = ''
export const PARAGRAPH_FONT_BOLD = ''
